import { Component, Injector, ViewEncapsulation } from '@angular/core';
import {
    GetPurchasesAndInvoicesByRelationshipRangeService,
    GetPurchasesByRelationshipRequest,
    GetPurchasesByRelationshipResponse,
    GetPurchasesByRelationshipService,
    Purchase
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { getRouterLinkById, ResponsiveService } from '@lsq-frontend/common-ui';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import { of } from 'rxjs';
import { AnalyticsValue } from '../../../../../constants/analytics.constants';
import { customerAtlas, CUSTOMER_PURCHASES } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { ByCustomerDateRangeReportComponent } from '../../../../reports/base/by-customer-date-range-report.component';
import { ReportSavedDateFilterNames } from '../../../../services/saved-date-filter.service';
import { CustomerDetailUserStateTypes } from '../../customer-detail.user-state-types';

@Component({
    selector: 'purchases-by-customer-report',
    template: `
        <div id="purchases-customer-report-page-container" class="container-fluid page-container">
            <div class="table" *ngIf="dataSource">
                <purchases-by-customer-grouped-table
                    [dataSource]="dataSource"
                    [debtorKey]="debtorKey"
                    [groupBy]="groupPurchasesBy"
                    (requestChange)="dataSource.dispatchRequest($event)"
                >
                </purchases-by-customer-grouped-table>
            </div>
        </div>
    `,
    styleUrls: ['./purchases-by-customer.report.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PurchasesByCustomerReportComponent extends ByCustomerDateRangeReportComponent {
    public title = 'Purchases';
    public groupPurchasesBy = 'purchaseDate';
    public analyticsName = AnalyticsValue.PurchasesCustomer;
    public userStateType = CustomerDetailUserStateTypes.GetPurchasesByRelationshipRequest;
    public savedDateFilterName = ReportSavedDateFilterNames.PurchasesByCustomerReport;

    public dataSource = new LsqApiServiceListSource<
        GetPurchasesByRelationshipResponse,
        GetPurchasesByRelationshipRequest,
        Purchase[]
    >(this.apiService);

    constructor(
        public apiService: GetPurchasesByRelationshipService,
        public getPurchasesAndInvoicesByRelationshipRangeService: GetPurchasesAndInvoicesByRelationshipRangeService,
        public responsiveService: ResponsiveService,
        public injector: Injector
    ) {
        super(injector);

        this.dispatchInitialRequest();
    }

    public updateCustomerDetailBanner(): void {
        this.getPurchasesAndInvoicesByRelationshipRangeService.setRequestStream(
            of(this.dataSource.request)
        );

        this.customerDetailService.updateBanner({
            title: this.debtorName || this.title,
            debtorName: this.debtorName,
            debtorKey: this.debtorKey,
            lastUpdatedDate: this.lastUpdatedDate,
            reportName: `${this.title} ${this.debtorName}`,
            reportId: getRouterLinkById(customerAtlas, CUSTOMER_PURCHASES, { relative: true }).join(
                '/'
            ),
            analyticsName: this.analyticsName,
            apiService: this.getPurchasesAndInvoicesByRelationshipRangeService,
            datePickerConfiguration: this.datePickerConfiguration
        });
    }
}
